import { Page } from "@roc/feature-app-core";
import { Route } from "react-router";
import { SendWireContainer } from "../components/sendWireContainer";
import { useRocInternalPortalStore } from "apps/roc-internal-portal/src/app/hooks";

export const getSendWireRoutesConfig = (
  basePath: string,
  baseUrl: string
)  => {
  return {
    sendWire: {
      path: `${basePath}/send-wire`,
      url: `${baseUrl}/send-wire`,
      documentTitle: 'Send Wire',
    },
  };
};
export const getSendWireRoutes = (
  basePath: string,
  baseUrl: string
) => {
  const config = getSendWireRoutesConfig(basePath, baseUrl);
  return {
    sendWire: (
      <Route exact path={config.sendWire.path}>
        <Page routeDefinition={config.sendWire}>
          <SendWireContainer/>
        </Page>
      </Route>
    )
  }
}